module.exports = __webpack_public_path__ + "static/media/g2.feb14bd6.jpg";